import api from "../axios";

export async function getFinancialOverviewKpis(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/financial-overview/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}

export async function getRevenueTrend(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/revenue-trend-rpm-vs-ccm/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}

export async function getCPTCodesGenerated(scope = "all", month, categoryFilter) {
  const response = await api.get("api/dashboards/kpis/cpt-codes-generated/", {
    params: {
      scope,
      ...(month ? { month } : {}),
      ...(categoryFilter ? { category_filter: categoryFilter } : {}),
    },
  });

  return response.data;
}

export async function getRampUpAndBillablePatients(scope = "all", month) {
  const response = await api.get("api/dashboards/kpis/ramp-up-and-billable-patients/", {
    params: {
      scope,
      ...(month ? { month } : {}),
    },
  });

  return response.data;
}
